import formatFloatForDisplay from 'services/numbers/formatFloatForDisplay';

export default (value: number, roundToDecimals = 2): string => {
  return formatFloatForDisplay(value, roundToDecimals, {});
};
